var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "div",
        {
          staticClass: "setting flex-row jc-start",
          staticStyle: { "margin-bottom": "10px" },
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                icon: _vm.settingType ? "el-icon-edit" : "el-icon-view",
                size: "medium",
                type: _vm.settingType ? "warning" : "",
              },
              on: { click: _vm.handSetting },
            },
            [_vm._v(_vm._s(_vm.settingType ? "编辑" : "确定") + " ")]
          ),
        ],
        1
      ),
      _c("el-row", [
        _c("div", { staticClass: "homeLayout" }, [
          _c(
            "div",
            { staticClass: "layout_bg bordersolid" },
            [
              _c(
                "el-col",
                { staticClass: "pl16 pr16", attrs: { span: 24 } },
                [
                  _c("el-divider", { attrs: { "content-position": "left" } }, [
                    _vm._v("标题内容"),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "mg16", attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: "5",
                          disabled: _vm.settingType,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeInput($event, _vm.aboutUsContent)
                          },
                        },
                        model: {
                          value: _vm.aboutUsContent.valEn,
                          callback: function ($$v) {
                            _vm.$set(_vm.aboutUsContent, "valEn", $$v)
                          },
                          expression: "aboutUsContent.valEn",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-input", {
                        staticClass: " ml16",
                        attrs: {
                          type: "textarea",
                          rows: "5",
                          disabled: _vm.settingType,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeInput($event, _vm.aboutUsContent)
                          },
                        },
                        model: {
                          value: _vm.aboutUsContent.valCn,
                          callback: function ($$v) {
                            _vm.$set(_vm.aboutUsContent, "valCn", $$v)
                          },
                          expression: "aboutUsContent.valCn",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "bordersolid mt4" },
            [
              _c(
                "el-row",
                { staticClass: "pd16" },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [_vm._v("视频")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("CropperView", {
                        attrs: {
                          imgSrc: _vm.vidoForm.pic,
                          disabled: _vm.settingType,
                          actionButtonFlag: true,
                          objectFit: "cover",
                          listIndex: 1,
                          maxVideoSize: _vm.uploadVideoSize,
                        },
                        on: {
                          updateChange: function ($event) {
                            return _vm.changeImage2($event, _vm.vidoForm)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "bordersolid mt4" },
            [
              _c(
                "el-row",
                { staticClass: "pd16" },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [_vm._v("展厅")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.settingType,
                          placeholder: "请输入标题",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeInput($event, _vm.galleryTitle)
                          },
                        },
                        model: {
                          value: _vm.galleryTitle.valEn,
                          callback: function ($$v) {
                            _vm.$set(_vm.galleryTitle, "valEn", $$v)
                          },
                          expression: "galleryTitle.valEn",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-input", {
                        staticClass: "ml16",
                        attrs: {
                          disabled: _vm.settingType,
                          placeholder: "请输入标题",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeInput($event, _vm.galleryTitle)
                          },
                        },
                        model: {
                          value: _vm.galleryTitle.valCn,
                          callback: function ($$v) {
                            _vm.$set(_vm.galleryTitle, "valCn", $$v)
                          },
                          expression: "galleryTitle.valCn",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-input", {
                        staticClass: "mt16",
                        attrs: {
                          type: "textarea",
                          rows: "5",
                          placeholder: "请输入内容",
                          disabled: _vm.settingType,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeInput($event, _vm.galleryContent)
                          },
                        },
                        model: {
                          value: _vm.galleryContent.valEn,
                          callback: function ($$v) {
                            _vm.$set(_vm.galleryContent, "valEn", $$v)
                          },
                          expression: "galleryContent.valEn",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-input", {
                        staticClass: "ml16 mt16",
                        attrs: {
                          type: "textarea",
                          rows: "5",
                          placeholder: "请输入内容",
                          disabled: _vm.settingType,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeInput($event, _vm.galleryContent)
                          },
                        },
                        model: {
                          value: _vm.galleryContent.valCn,
                          callback: function ($$v) {
                            _vm.$set(_vm.galleryContent, "valCn", $$v)
                          },
                          expression: "galleryContent.valCn",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "mt16", attrs: { span: 24 } },
                    [
                      _c("ImageUploadDraggableBtn", {
                        key: "galleryForm",
                        attrs: {
                          draggable: true,
                          itemActivityForm: true,
                          ifSetUploadName: true,
                          ownerId: _vm.galleryForm.id,
                          uploadInfo: {
                            type: "gallery",
                            title: "展览集",
                            category: "about",
                            categoryName: "关于我们",
                            tip: "请先输入英文名称",
                            fileName: "about",
                          },
                          disabled: _vm.settingType,
                          otherPrams: _vm.otherPrams,
                          action: "/unmfile/cecUnmFileupload",
                          tip: "单个图片不要超过10M,可拖动列表行排序",
                        },
                        on: {
                          updateDet: function ($event) {
                            return _vm.doSubmit()
                          },
                          updateChange: function ($event) {
                            return _vm.handImageList($event, "galleryForm")
                          },
                        },
                        model: {
                          value: _vm.galleryForm.gallery,
                          callback: function ($$v) {
                            _vm.$set(_vm.galleryForm, "gallery", $$v)
                          },
                          expression: "galleryForm.gallery",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "bordersolid mt4" },
            [
              _c(
                "el-row",
                { staticClass: "pd16" },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [_vm._v("办公室")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.settingType,
                          placeholder: "请输入标题",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeInput(
                              $event,
                              _vm.galleryOfficeTitle
                            )
                          },
                        },
                        model: {
                          value: _vm.galleryOfficeTitle.valEn,
                          callback: function ($$v) {
                            _vm.$set(_vm.galleryOfficeTitle, "valEn", $$v)
                          },
                          expression: "galleryOfficeTitle.valEn",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-input", {
                        staticClass: "ml16",
                        attrs: {
                          disabled: _vm.settingType,
                          placeholder: "请输入标题",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeInput(
                              $event,
                              _vm.galleryOfficeTitle
                            )
                          },
                        },
                        model: {
                          value: _vm.galleryOfficeTitle.valCn,
                          callback: function ($$v) {
                            _vm.$set(_vm.galleryOfficeTitle, "valCn", $$v)
                          },
                          expression: "galleryOfficeTitle.valCn",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-input", {
                        staticClass: "mt16",
                        attrs: {
                          type: "textarea",
                          rows: "5",
                          placeholder: "请输入内容",
                          disabled: _vm.settingType,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeInput(
                              $event,
                              _vm.galleryOfficeContent
                            )
                          },
                        },
                        model: {
                          value: _vm.galleryOfficeContent.valEn,
                          callback: function ($$v) {
                            _vm.$set(_vm.galleryOfficeContent, "valEn", $$v)
                          },
                          expression: "galleryOfficeContent.valEn",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-input", {
                        staticClass: "ml16 mt16",
                        attrs: {
                          type: "textarea",
                          rows: "5",
                          placeholder: "请输入内容",
                          disabled: _vm.settingType,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeInput(
                              $event,
                              _vm.galleryOfficeContent
                            )
                          },
                        },
                        model: {
                          value: _vm.galleryOfficeContent.valCn,
                          callback: function ($$v) {
                            _vm.$set(_vm.galleryOfficeContent, "valCn", $$v)
                          },
                          expression: "galleryOfficeContent.valCn",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "mt16", attrs: { span: 24 } },
                    [
                      _c("ImageUploadDraggableBtn", {
                        key: "galleryOfficeForm",
                        attrs: {
                          draggable: true,
                          itemActivityForm: true,
                          ifSetUploadName: true,
                          ownerId: _vm.galleryOfficeForm.id,
                          uploadInfo: {
                            type: "gallery",
                            title: "展览集-办公室",
                            category: "about",
                            categoryName: "关于我们",
                            tip: "请先输入英文名称",
                            fileName: "about",
                          },
                          disabled: _vm.settingType,
                          otherPrams: _vm.otherPrams,
                          action: "/unmfile/cecUnmFileupload",
                          tip: "单个图片不要超过10M,可拖动列表行排序",
                        },
                        on: {
                          updateDet: function ($event) {
                            return _vm.doSubmit()
                          },
                          updateChange: function ($event) {
                            return _vm.handImageList(
                              $event,
                              "galleryOfficeForm"
                            )
                          },
                        },
                        model: {
                          value: _vm.galleryOfficeForm.gallery,
                          callback: function ($$v) {
                            _vm.$set(_vm.galleryOfficeForm, "gallery", $$v)
                          },
                          expression: "galleryOfficeForm.gallery",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "bordersolid mt4" },
            [
              _c(
                "el-row",
                { staticClass: "pd16" },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [_vm._v("仓库")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.settingType,
                          placeholder: "请输入标题",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeInput(
                              $event,
                              _vm.galleryWarehouseTitle
                            )
                          },
                        },
                        model: {
                          value: _vm.galleryWarehouseTitle.valEn,
                          callback: function ($$v) {
                            _vm.$set(_vm.galleryWarehouseTitle, "valEn", $$v)
                          },
                          expression: "galleryWarehouseTitle.valEn",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-input", {
                        staticClass: "ml16",
                        attrs: {
                          disabled: _vm.settingType,
                          placeholder: "请输入标题",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeInput(
                              $event,
                              _vm.galleryWarehouseTitle
                            )
                          },
                        },
                        model: {
                          value: _vm.galleryWarehouseTitle.valCn,
                          callback: function ($$v) {
                            _vm.$set(_vm.galleryWarehouseTitle, "valCn", $$v)
                          },
                          expression: "galleryWarehouseTitle.valCn",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-input", {
                        staticClass: "mt16",
                        attrs: {
                          type: "textarea",
                          rows: "5",
                          placeholder: "请输入内容",
                          disabled: _vm.settingType,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeInput(
                              $event,
                              _vm.galleryWarehouseContent
                            )
                          },
                        },
                        model: {
                          value: _vm.galleryWarehouseContent.valEn,
                          callback: function ($$v) {
                            _vm.$set(_vm.galleryWarehouseContent, "valEn", $$v)
                          },
                          expression: "galleryWarehouseContent.valEn",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-input", {
                        staticClass: "ml16 mt16",
                        attrs: {
                          type: "textarea",
                          rows: "5",
                          placeholder: "请输入内容",
                          disabled: _vm.settingType,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeInput(
                              $event,
                              _vm.galleryWarehouseContent
                            )
                          },
                        },
                        model: {
                          value: _vm.galleryWarehouseContent.valCn,
                          callback: function ($$v) {
                            _vm.$set(_vm.galleryWarehouseContent, "valCn", $$v)
                          },
                          expression: "galleryWarehouseContent.valCn",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "mt16", attrs: { span: 24 } },
                    [
                      _c("ImageUploadDraggableBtn", {
                        key: "galleryWarehouseForm",
                        attrs: {
                          draggable: true,
                          itemActivityForm: true,
                          ifSetUploadName: true,
                          ownerId: _vm.galleryWarehouseForm.id,
                          uploadInfo: {
                            type: "gallery",
                            title: "展览集-仓库",
                            category: "about",
                            categoryName: "关于我们",
                            tip: "请先输入英文名称",
                            fileName: "about",
                          },
                          disabled: _vm.settingType,
                          otherPrams: _vm.otherPrams,
                          action: "/unmfile/cecUnmFileupload",
                          tip: "单个图片不要超过10M,可拖动列表行排序",
                        },
                        on: {
                          updateDet: function ($event) {
                            return _vm.doSubmit()
                          },
                          updateChange: function ($event) {
                            return _vm.handImageList(
                              $event,
                              "galleryWarehouseForm"
                            )
                          },
                        },
                        model: {
                          value: _vm.galleryWarehouseForm.gallery,
                          callback: function ($$v) {
                            _vm.$set(_vm.galleryWarehouseForm, "gallery", $$v)
                          },
                          expression: "galleryWarehouseForm.gallery",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: " bordersolid mt4 pd16" }, [
            _c(
              "div",
              {},
              [
                _c("el-divider", { attrs: { "content-position": "left" } }, [
                  _vm._v("合作伙伴"),
                ]),
              ],
              1
            ),
            _c("div", { staticClass: "flex-row ai-center jc-evenly" }, [
              _c("div", [
                _c(
                  "div",
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 15 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("el-input", {
                              staticClass: "inputWidth",
                              attrs: {
                                type: "textarea",
                                rows: "5",
                                disabled: _vm.settingType,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeInput(
                                    $event,
                                    _vm.aboutUsCpTitle
                                  )
                                },
                              },
                              model: {
                                value: _vm.aboutUsCpTitle.valEn,
                                callback: function ($$v) {
                                  _vm.$set(_vm.aboutUsCpTitle, "valEn", $$v)
                                },
                                expression: "aboutUsCpTitle.valEn",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("el-input", {
                              staticClass: "inputWidth",
                              attrs: {
                                type: "textarea",
                                rows: "5",
                                disabled: _vm.settingType,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeInput(
                                    $event,
                                    _vm.aboutUsCpTitle
                                  )
                                },
                              },
                              model: {
                                value: _vm.aboutUsCpTitle.valCn,
                                callback: function ($$v) {
                                  _vm.$set(_vm.aboutUsCpTitle, "valCn", $$v)
                                },
                                expression: "aboutUsCpTitle.valCn",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                [
                  _c("image-upload-new", {
                    staticClass: "mb8",
                    attrs: {
                      disabled: _vm.settingType,
                      limit: 3,
                      tip: "单个图片不要超过10M",
                    },
                    on: {
                      updateChange: function ($event) {
                        return _vm.changeImage($event, _vm.aboutUsCpImageTop)
                      },
                    },
                    model: {
                      value: _vm.aboutUsCpImageTop.pic,
                      callback: function ($$v) {
                        _vm.$set(_vm.aboutUsCpImageTop, "pic", $$v)
                      },
                      expression: "aboutUsCpImageTop.pic",
                    },
                  }),
                  _c("image-upload-new", {
                    staticClass: "mb8",
                    attrs: {
                      disabled: _vm.settingType,
                      limit: 3,
                      tip: "单个图片不要超过10M",
                    },
                    on: {
                      updateChange: function ($event) {
                        return _vm.changeImage($event, _vm.aboutUsCpImageBottom)
                      },
                    },
                    model: {
                      value: _vm.aboutUsCpImageBottom.pic,
                      callback: function ($$v) {
                        _vm.$set(_vm.aboutUsCpImageBottom, "pic", $$v)
                      },
                      expression: "aboutUsCpImageBottom.pic",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }